import React, { useRef, useState } from "react";
import "../styles/Map.css";
import bgImage from "../assets/map-bg.png";

import emailjs from "@emailjs/browser";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Map = () => {
  const formRef = useRef();
  const [loading, setLoading] = useState(false);

  // Hover circle animation
  const handleMove = (e) => {
    const btn = e.currentTarget;
    const circle = btn.querySelector(".maha-map-circle");

    const rect = btn.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    if (circle) {
      circle.style.left = `${x}px`;
      circle.style.top = `${y}px`;
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    emailjs
      .sendForm(
        "service_32l1fhe",
        "template_lf4c1bc",
        formRef.current,
        {
          publicKey: "mspwhvbpx7S13jte4",
        }
      )
      .then(
        () => {
          toast.success("Message sent successfully!");
          formRef.current.reset();
          setLoading(false);
        },
        (error) => {
          console.log("STATUS:", error.status);
          console.log("ERROR:", error.text);
          toast.error("Failed to send message.");
          setLoading(false);
        }
      );
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    name: "Maha Cabs Tempo Traveller Mayiladuthurai",
    telephone: "+919486589488",
    address: {
      "@type": "PostalAddress",
      addressLocality: "Mayiladuthurai",
      addressRegion: "Tamil Nadu",
      addressCountry: "IN",
    },
  };

  return (
    <section
      className="map-section"
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(localBusinessSchema),
        }}
      />

      <ToastContainer position="top-right" autoClose={3000} />

      <div className="map-overlay"></div>

      <div className="map-container">
        {/* LEFT MAP */}
        <div className="map-left">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d154158.2856903608!2d79.4984428972656!3d11.103608400000006!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a5521efe37e81f7%3A0x61625c01401854db!2sMAHA%20CABS%20TEMPO%20TRAVELLER%20MAYILADUTHURAI!5e1!3m2!1sen!2sin!4v1770371927336!5m2!1sen!2sin"
            width="600"
            height="450"
            allowFullScreen=""
            loading="lazy"
            title="Maha Cabs Location"
          ></iframe>
        </div>

        {/* RIGHT FORM */}
        <div className="map-right">
          <h2>Contact Us</h2>

          <form ref={formRef} onSubmit={handleSubmit}>
            
            {/* MUST MATCH TEMPLATE VARIABLES */}

            <input
              type="text"
              name="from_name"   // ✅ matches {{from_name}}
              placeholder="Your Name"
              required
            />

            <input
              type="email"
              name="email"       // ✅ matches {{email}}
              placeholder="Your Email"
              required
            />

            <input
              type="tel"
              name="mobile"      // ✅ matches {{mobile}}
              placeholder="Mobile Number"
              required
            />

            <textarea
              name="message"     // ✅ matches {{message}}
              rows="5"
              placeholder="Your Message"
              required
            ></textarea>

            <button
              type="submit"
              className="maha-map-btn"
              onMouseMove={handleMove}
              disabled={loading}
            >
              <span className="maha-map-circle"></span>
              {loading ? "Sending..." : "Send Message"}
            </button>

          </form>
        </div>
      </div>
    </section>
  );
};

export default Map;